import mergeProps from "@/router/utils/mergeProps";
import redirectByName from "@/router/utils/redirectByName";


// let ToolsMain = () => import(/* webpackChunkName: "tools" */ '@/tools/ToolsMain')
let EmptyRouterView = () => import("@/core/components/EmptyRouterView.vue");
let SessionPlanPrintPage = () => import("@tl/core/modules/commission/details/sessionPlan/SessionPlanPrintPage.vue");
let GenericToolPrintPage = () => import("@/core/modules/coach/Resources/CoachingTools/GenericTools/GenericToolPrintPage.vue");

export default [
	{
		path: '/print',
		name: 'print',
		component: EmptyRouterView,
		props: mergeProps,
		meta: {
			isWhitelisted: true,
			isPrintView: true,
		},
		children: [
			{
				path: 'session-plan',
				name: 'PrintSessionPlan',
				props: mergeProps,
				component: SessionPlanPrintPage,
			},
			{
				path: 'tools',
				name: 'PrintGenericTool',
				props: mergeProps,
				component: GenericToolPrintPage,
			},
		]
	},

]
